module.exports = __webpack_public_path__ + "assets/src/style/img/footer-gemeente-assen.png?9dbaa934e1cc136055a2506edded72a4";